import React, { useState } from "react";

function FAQSection() {
    const questions = [
        {
            id: 1,
            question:
                "What makes Oakmate different from other chess analysis tools?",
            answer: "Oakmate offers a generous free tier with all the core analysis features you need, plus a Pro plan with AI coaching, cloud analysis, custom puzzles, and long-term improvement tracking. It runs as a Chrome extension so you can analyze your games instantly in a popup overlay without switching sites.",
        },
        {
            id: 2,
            question: "Which platforms does Oakmate work with?",
            answer: "Oakmate works seamlessly with both Chess.com and Lichess via their public APIs. Just open a completed game, click the Oakmate icon, and the analysis will appear in a popup overlay.",
        },
        {
            id: 3,
            question: "Is Oakmate allowed on major chess platforms?",
            answer: "Yes. Oakmate only uses public APIs and never modifies website code or injects scripts. It's fully compliant with the terms of service of both Chess.com and Lichess.",
        },
        {
            id: 4,
            question: "How does Oakmate's analysis work?",
            answer: "When you click the Oakmate icon, your game data is fetched from the platform's API, then analyzed either locally using Stockfish in your browser or through Pro's cloud servers for faster results. The extension uses a content script to display the results in a popup overlay directly on your game page.",
        },
        {
            id: 5,
            question: "Is Oakmate free?",
            answer: "Yes. The free plan includes all the essential features for unlimited analysis. You can upgrade to Pro anytime to unlock AI insights, faster cloud analysis, and advanced training tools.",
        },
    ];

    const Question = (props) => {
        const [isActive, setActive] = useState(false);
        const handleClick = () => {
            setActive(!isActive);
        };
        return (
            <article onClick={handleClick} className="question-wrapper">
                <header className="question" id={props.id}>
                    <h3>{props.question}</h3>
                    <svg
                        className={
                            isActive ? "angle-down-active" : "angle-down"
                        }
                        viewBox="0 0 320 512"
                        title="angle-down"
                    >
                        <path d="M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z" />
                    </svg>
                </header>
                <div className={isActive ? "answer active" : "answer"}>
                    {props.answer}
                </div>
            </article>
        );
    };

    return (
        <>
            <header className="section-title-container">
                <h2 className="section-title">Frequently Asked Questions</h2>
                <p className="section-subtitle">
                    Still Have Doubts? Chat with our support team or join our
                    community
                </p>
            </header>
            <div className="faq-section-wrapper">
                {questions.map((item) => (
                    <Question
                        key={item.id}
                        question={item.question}
                        answer={item.answer}
                    />
                ))}
            </div>
        </>
    );
}

export default FAQSection;
